<ejs-dialog #buildModalDialog [isModal]='isModal' [buttons]='buildDlgButtons' [visible]='buildModalDialogVisible'
            [position]='position' [animationSettings]='animationSettings' [width]='modalWidth' (open)="splVersionModalOpen()">
  <ng-template #content>
    <div class="card">
      <div class="card-header bg-primary">
        <h3 class="card-title text-white" tabindex="0" role="heading" aria-label="Update SPL Version Number" aria-level="3">Update SPL Version Number</h3>
      </div>
      <div class="card-body">
        <label id="splVersionNumber-label">The SPL Version number will be updated to the next major version below</label>
        <input id='splVersionModalInput' type="number" min="1" oninput="this.value = Math.abs(this.value) || this.value > 0"
               onkeydown="if(event.key==='.'){event.preventDefault();}"
               class="form-control" (blur)="validateSplVersionInput($event)"
               aria-labelledby="splVersionNumber-label" tabindex="0" role="spinbutton"/>

        <div *ngIf="invalidSplVersion" class="alert-text">
          <span aria-label="The SPL version can't be blank" tabindex="0">The SPL version can't be blank</span>
        </div>
      </div>
    </div>
  </ng-template>
</ejs-dialog>
